import { useQuery, useApolloClient } from '@apollo/client';
import { getOr } from 'lodash/fp';
import { CURRENT_ROUTE } from '../GraphQL/Queries';

const useRouter = () => {
  const { data } = useQuery(CURRENT_ROUTE);
  const client = useApolloClient();

  const switchRoute = (route, params = {}) => {
    client.writeQuery({
      query: CURRENT_ROUTE,
      data: {
        currentRoute: {
          __typename: 'currentRoute',
          route,
          params,
        },
      },
    });
  };

  return {
    currentRoute: getOr('/home', 'currentRoute.route', data),
    params: getOr({}, 'currentRoute.params', data),
    switchRoute,
  };
};

export default useRouter;
